import React, { useState } from "react";
import {
  Button,
  Snackbar,
  Alert,
  AlertTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Download } from "@mui/icons-material";

const DownloadButton = ({ textContent, fileName }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleDownload = () => {
    // Encode the text content with UTF-16
    const encoder = new TextEncoder("utf-16");
    const encodedContent = encoder.encode(textContent);
  
    // Create Blob with specified encoding
    const blob = new Blob([encodedContent], { type: "text/plain;charset=utf-16" });
  
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  
    // Show a Snackbar when the file is downloaded
    setShowSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  return (
    <>
      <Tooltip title={"Download"}>
        <IconButton
          endIcon={<Download />}
          onClick={handleDownload}
          color="inherit"
        >
          <Download />
        </IconButton>
      </Tooltip>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          <AlertTitle>Success</AlertTitle>
          {`File "${fileName}" downloaded successfully!`}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DownloadButton;
